// // этот код мешает работе кода ниже
// const choiceTitleForAlpineWhile = () => {
//   if (!document.querySelector('.cpb-theme-provider.alpine-white') || innerWidth > 999) return

//   let choiceTitles = {};
  
//   CPB.getStore().getState().Product.panels.forEach(p => p.categories.forEach(c => c.options.forEach(o => {
//     choiceTitles[o.id] = o.option.data.label;
//   })));

//   const updateTitles = () => {
//     for (let id in choiceTitles) {
//       const choceElem = document.querySelector(`.cpb-option-type-img[data-option-id="${id}"]`);
//       if (!choceElem) continue

//       const titleElem = document.createElement('span');
//       titleElem.classList.add('cpb-custom-option-descr');
//       titleElem.textContent = choiceTitles[id];

//       choceElem.append(titleElem);
//     };
//   };

//   updateTitles();
//   document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', updateTitles);
// }

// document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
//   choiceTitleForAlpineWhile();
// })
// // этот код мешает работе кода ниже

// Generic fallback: add captions based on img alt/title (mobile only)
(function () {
  if (window.innerWidth > 999) return;

  function addCaptions() {
    document.querySelectorAll('.cpb-option-type-img').forEach((wrapper) => {
      if (wrapper.querySelector('.cpb-custom-option-label')) return;

      const img = wrapper.querySelector('img');
      const title = img?.alt || img?.title || '';
      if (!title) return;

      const cap = document.createElement('div');
      cap.className = 'cpb-custom-option-label';
      cap.textContent = title;

      (img?.parentElement || wrapper).appendChild(cap);
    });
  }

  addCaptions();

  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', addCaptions);
  document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', addCaptions);

  const mo = new MutationObserver(addCaptions);
  mo.observe(document.body, { childList: true, subtree: true });
})();